<template>
  <div v-if="resumee">
    <action-bar></action-bar>
    <main class="content">
      <h1>
        Programm Resümee bearbeiten
        <br>
        <small class="text-muted">{{resumee.name.text}}</small>
      </h1>
      <a
        :href="portalBaseUrl + '/' + store.state.language + '/program_resumee/' + resumee.id"
        target="_blank"
      >
        <i class="fal fa-share"></i> Liveansicht
      </a> &nbsp;
      <a
        :href="portalBaseUrl + '/' + store.state.language + '/program_resumee/preview/' + resumee.id"
        target="_blank"
      >
        <i class="fal fa-share"></i> Vorschau aller Blöcke
      </a>
      <br>
      <br>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'program-resumee-edit' }"
            exact
          >Generelle Texte</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'program-resumee-edit-micropage'}"
          >Micropage</router-link>
        </li>
      </ul>
      <div class="tab-content">
        <router-view class="tab-pane fade show active" :data="resumee" entity="program_resumee"/>
      </div>
    </main>
  </div>
  <loading v-else></loading>
</template>
<script>
import moment from 'moment';

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    portalBaseUrl: function() {
      return portalBaseUrl;
    },
    store: function() {
      return store;
    }
  },
  asyncComputed: {
    resumee() {
      let promises = [];
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/program_resumee/get"
        )
      );
      promises.push(
        axios.get(
          "/api/" +
            store.state.language +
            "/program_resumee/blocks"
        )
      );

      return Promise.all(promises).then(responses => {
        let resumee = responses[0].data.result;
        resumee.blocks = responses[1].data.result;

        return resumee;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/program_resumee/Edit.vue